export const CARDS = 'CARDS';
export const TASKS = 'TASKS';
export const EDIT_FROM_SD_SETTINGS = 'editFromSdSettings';
export const DISPENSE_REPORT_NOTIFICATION = 'dispenseReportNotification';
export const BROADCAST_STATE_BEFORE_EDIT = 'broadcastStateBeforeEdit';
